module.exports = __webpack_public_path__ + "img/12.da3a1416.jpg";